import type { LocaleUrlBuilder } from '~/composables/types/localizable'
import {
  buildEventListPageLocaleUrl,
  buildMagazineLocaleUrl,
  buildDynamicStrapiPageLocaleUrl,
} from '~/composables/locale/urlBuilders'
import {
  isMagazineArticlePage,
  isEventListPage,
  isKitsPage,
  isDynamicStrapiPage,
} from '~/utils/routeHelpers'

export const useLocaleUrlBuilder = (): LocaleUrlBuilder => {
  const route = useRoute()
  if (isMagazineArticlePage(route)) return buildMagazineLocaleUrl
  if (isEventListPage(route) || isKitsPage(route))
    return buildEventListPageLocaleUrl
  if (isDynamicStrapiPage(route)) {
    const section = route.path.split('/').filter(Boolean)[1]
    return (localization, targetLocale) =>
      buildDynamicStrapiPageLocaleUrl(localization, targetLocale, section)
  }
  return () => null
}
